import Vue from "vue";
import Vuex from "vuex";
import { Module } from "vuex";
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import router from "@/router";
import moment from "moment";

const conciergeModule: Module<any, any> = {
  namespaced: false,
  state: {
    conciergeRequests: [],
    currentConciergeRequest: null,
    currentResidentOpenConciergeRequest: [],
    conciergeRequestAvgCompletion:[], 
    conciergeCategoryValues:[]
  },

  mutations: {
    setConciergeRequests(state: any, payload: []) {
      state.conciergeRequests = payload;
    },
    setCurrentConciergeRequest(state: any, payload: []) {
      state.currentConciergeRequest = payload;
    },
    setCurrentResidentConciergeRequests(state: any, payload: []) {
      state.currentResidentOpenConciergeRequest = payload;
    },
    setConciergeRequestAvgCompletion(state: any, payload: []){
      state.conciergeRequestAvgCompletion = payload
    }, 
    setConciergeCategoryValues(state: any, payload: []){
      state.conciergeCategoryValues = payload
    }
  },

  actions: {
    async getConciergeRequests({ commit }) {
      const now = moment(new Date());
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("state", "==", "New")
        .orderBy("requestedDateTime");
      await conciergeRequests.get().then((querySnapshot) => {
        const conReqs: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const conR = x.data();
          const reqDateTime = moment
            .duration(
              now.diff(moment(conR.requestedDateTime.seconds * 1000).toDate())
            )
            .asMinutes();
          conR.id = x.id;
          conR.requestAge = reqDateTime;
          conReqs.push(conR);
        });
        commit("setConciergeRequests", conReqs);
      });
    },
    async getConciergeRequestsByResident({ commit }, {residentId}) {
      const now = moment(new Date());
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("residentId", "==", residentId)
        .where("state", "==", "New")
        .orderBy("requestedDateTime");
      await conciergeRequests.get().then((querySnapshot) => {
        const conReqs: Array<any> = [];
        querySnapshot.docs.forEach((x) => {
          const conR = x.data();
          const reqDateTime = moment
            .duration(
              now.diff(moment(conR.requestedDateTime.seconds * 1000).toDate())
            )
            .asMinutes();
          conR.id = x.id;
          conR.requestAge = reqDateTime;
          conReqs.push(conR);
        });
        commit("setCurrentResidentConciergeRequests", conReqs);
      });
    },

    async getConciergeRequest({ commit }, id) {
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .doc(id);
      await conciergeRequests.get().then((querySnapshot) => {
        const currentSoc = querySnapshot.data();
        if (currentSoc != null) {
          currentSoc.id = querySnapshot.id;
          if(currentSoc.DateTime)
            currentSoc.DateTime = moment(currentSoc.DateTime.seconds * 1000).toDate();
          currentSoc.Date = moment(currentSoc.requestedDateTime.seconds * 1000).format("DD/MM/YY hh:mm A")
          commit("setCurrentConciergeRequest", currentSoc);
        }
      });

      router.push("/conciergeRequests/" + id);
    },

    async getConciergeRequestAvgCompletion({ commit }) {
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .where("facilityId", "==", this.state.authModule.currentFacility)
        .where("state", "==", "complete")
      await conciergeRequests.get().then((querySnapshot) => {
        const conciergeReqs: Array<any> = [];
        querySnapshot.docs.forEach((req) => {
          const conReg = req.data();
          const now = moment(conReg.completedDateTime.seconds*1000);
          const completionTime = moment
            .duration(now.diff(moment(conReg.requestedDateTime.seconds * 1000).toDate()))
            .asMinutes();
          conReg.id = req.id;
          conReg.completionTime = completionTime;
          conciergeReqs.push(conReg);
        });
        commit("setConciergeRequestAvgCompletion", conciergeReqs);
      });
    },

    async getConciergeCategoryValues({ commit }) {
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .where("facilityId", "==", this.state.authModule.currentFacility)

      await conciergeRequests.get().then((querySnapshot) => {
        const concReqs: Array<any> = [];
        let hairAppt = 0;
        let socEvent = 0;
        let orgTransport = 0;
        let helpWithReshub = 0;
        let breakyInBed = 0;
        querySnapshot.docs.forEach((req) => {
          const cncReg = req.data();
          if (cncReg.category == 'Setup a Hair Appt'){
            hairAppt++
          }else if (cncReg.category == 'Setup a Social Event'){
            socEvent++
          }else if (cncReg.category =='Organise Transport'){
            orgTransport++
          }else if (cncReg.category == 'Get Help with ResHub'){
            helpWithReshub++
          }else if (cncReg.category == 'Breakfast in Bed'){
            breakyInBed++
          }
        });
        concReqs.push(hairAppt,socEvent, orgTransport, helpWithReshub, breakyInBed)
        commit("setConciergeCategoryValues", concReqs);
      });
    },

    async completeConciergeRequest({ commit }, {id, additionalResponse}) {
      const conciergeRequests = firebase
        .firestore()
        .collection("conciergeRequests")
        .doc(id);
        const completedDateTime = firebase.firestore.Timestamp.now()
      await conciergeRequests.update({ state: "complete", "additionalResponse": additionalResponse, "completedDateTime": completedDateTime});

      router.push("/conciergeRequests");
    }
  },
};
export default conciergeModule;
